import { ValidatorClient } from "./_client";

export const dynamic = "force-dynamic";

export default function ValidatorAdminPage() {
  return (
    <div>
      <div className="mb-6">
        <h2 className="font-display font-semibold text-lg mb-1">Schema Validator</h2>
        <p className="text-sm text-ink-muted">
          Dán URL bất kỳ — kéo HTML, parse mọi JSON-LD và check field bắt buộc cho từng
          @type (Article / Organization / WebSite / BreadcrumbList / FAQPage…). Tích hợp
          Google Rich Results Test ở cuối kết quả.
        </p>
      </div>
      <ValidatorClient />
    </div>
  );
}
